<div style="width: 100%; position: relative">
  <rask-map [settings]="mapsettings">
    <rask-map-viapunkter></rask-map-viapunkter>
    <rask-map-layers></rask-map-layers>
  </rask-map>

  <div #popup [hidden]="!clickedItem.visible" class="popup" (click)="hideTooltip()">
    <small>{{clickedItem.label}} </small>
    @if (selectedGeometry?.id.includes('viapunkter')) {
      <i
        class="trash-color fal fa-lg fa-trash-alt"
        role="button"
        (click)="deleteViapunkt(selectedGeometry.easting, selectedGeometry.northing)">
      </i>
    }
  </div>
</div>